
import { createApp, reactive } from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';

// Configure Axios defaults
// axios.defaults.baseURL = 'http://localhost:3000/api';
axios.defaults.withCredentials = true; // Crucial for session cookies

// Simple reactive store for authentication
const authStore = reactive({
  user: null,
  isAuthenticated: false,
  setUser(userData) {
    this.user = userData;
    this.isAuthenticated = !!userData;
  },
  logout() {
    this.user = null;
    this.isAuthenticated = false;
  }
});

// --- Axios Response Interceptor ---
// This will run on every response from the backend
axios.interceptors.response.use(
  (response) => response, // Simply return successful responses
  (error) => {
    // If a response has a 401 status, it means the session is invalid or expired
    if (error.response && error.response.status === 401) {
      // If we are not already on the login page, redirect there
      if (router.currentRoute.value.name !== 'Login') {
        authStore.logout();
        router.push({ name: 'Login' });
      }
    }
    return Promise.reject(error);
  }
);

const app = createApp(App);

// Provide store and axios to all components
app.provide('auth', authStore);
app.config.globalProperties.$axios = axios;

app.use(router);

// --- Initial Authentication Check ---
// Before mounting the app, check for an existing session
async function initializeApp() {
  try {
    const response = await axios.get('/api/check-session');
    authStore.setUser(response.data);
  } catch (error) {
    authStore.setUser(null);
  } finally {
    // If not authenticated and trying to access a protected page, redirect to login
    if (!authStore.isAuthenticated && router.currentRoute.value.name !== 'Login') {
      await router.push({ name: 'Login' });
    }
    app.mount('#app');
  }
}

initializeApp();
